[
  {
    "id": 1,
    "price": 23,
    "abstract": "<p>Masticativo raro e pregiato, ideale per cani esperti.</p>\n",
    "description": "<p><strong>Masticativo raro e pregiato, ideale per cani esperti.</strong></p>\n<p>🔹 <strong>Molto duro ma friabile, di breve durata</strong>, garantisce un elevato livello di appagamento.<br>\n🔹 <strong>Non adatto ai cuccioli sotto i 5 mesi.</strong></p>\n<h2>Benefici e utilizzo</h2>\n<p>✔️ <strong>Ricco di aminoacidi e microelementi</strong>, con effetti positivi su <strong>pelle e pelo</strong>.<br>\n✔️ <strong>Favorisce la digestione</strong> e aiuta nella <strong>pulizia dei denti</strong>, rafforzando le gengive.<br>\n✔️ <strong>Dosaggio consigliato:</strong> fino a <strong>4-7 pezzi al giorno per un cane di circa 25 kg</strong>, senza controindicazioni.<br>\n✔️ <strong>Indicato in classi di comunicazione</strong> per migliorare e valutare gli indici di socialità del cane</p>\n<p>👉 <strong>Un prodotto imprescindibile per i professionisti del settore.</strong></p>\n",
    "name": "Aorta di Bovino",
    "slug": "aorta",
    "specs": "<p>🔬 <strong>Analisi nutrizionale</strong> (valori in g per 100 g):</p>\n<ul>\n<li><strong>Umidità</strong>: 7,84 g <em>(Rapporti ISTISAN 1996/34 pag.7 Met. B ± 0,2)</em></li>\n<li><strong>Sostanze grasse totali</strong>: 9,86 g <em>(MP/C/071 rev3 06/20 ± 0,28)</em></li>\n<li><strong>Sostanze azotate totali (Proteine)</strong>: 75,2 g <em>(MP/C/057 rev5 06/20 ± 0,40)</em></li>\n<li><strong>Ceneri</strong>: 5,92 g <em>(MP/C/056 rev3 06/20 ± 0,050)</em></li>\n<li><strong>Fibra</strong>: 0,76 g <em>(AACC method 32-10.01)</em></li>\n</ul>\n",
    "Tipo": "Bovino",
    "Order": 1,
    "isComingSoon": false,
    "locale": "it",
    "published_at": "2025-01-24T20:38:05.817Z",
    "created_at": "2025-01-24T20:38:02.172Z",
    "updated_at": "2025-07-14T07:33:27.555Z",
    "img": {
      "id": 47,
      "name": "Aorta v1.jpg",
      "alternativeText": "",
      "caption": "",
      "width": 1600,
      "height": 1600,
      "formats": {
        "thumbnail": {
          "name": "thumbnail_Aorta v1.jpg",
          "hash": "thumbnail_Aorta_v1_2626225544",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 156,
          "height": 156,
          "size": 4.19,
          "path": null,
          "url": "/uploads/thumbnail_Aorta_v1_2626225544.jpg"
        },
        "large": {
          "name": "large_Aorta v1.jpg",
          "hash": "large_Aorta_v1_2626225544",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 1000,
          "height": 1000,
          "size": 89.67,
          "path": null,
          "url": "/uploads/large_Aorta_v1_2626225544.jpg"
        },
        "medium": {
          "name": "medium_Aorta v1.jpg",
          "hash": "medium_Aorta_v1_2626225544",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 750,
          "height": 750,
          "size": 55.36,
          "path": null,
          "url": "/uploads/medium_Aorta_v1_2626225544.jpg"
        },
        "small": {
          "name": "small_Aorta v1.jpg",
          "hash": "small_Aorta_v1_2626225544",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 500,
          "height": 500,
          "size": 29.39,
          "path": null,
          "url": "/uploads/small_Aorta_v1_2626225544.jpg"
        }
      },
      "hash": "Aorta_v1_2626225544",
      "ext": ".jpg",
      "mime": "image/jpeg",
      "size": 177.7,
      "url": "/uploads/Aorta_v1_2626225544.jpg",
      "previewUrl": null,
      "provider": "local",
      "provider_metadata": null,
      "created_at": "2025-02-08T14:13:52.893Z",
      "updated_at": "2025-02-08T14:13:52.902Z"
    },
    "localizations": []
  },
  {
    "id": 3,
    "price": 18,
    "abstract": "<p>Adatta a cani di tutte le età e taglie con una minima esperienza di masticazione.</p>\n",
    "description": "<p><strong>Adatta a cani di tutte le età e taglie con una minima esperienza di masticazione.</strong></p>\n<p>🔹 <strong>Per cuccioli:</strong> un'ottima attività di stimolazione, di condivisione e gestione della competitività inter e intra specifica.<br>\n🔹 <strong>Per adulti:</strong> un'ottima scelta per stimolare l'attività masticatoria prolungata.<br>\n🔹 <strong>Per cani anziani:</strong> assicurarsi che abbiano una dentatura completa, poiché questo masticativo richiede una leggera pressione sui molari.<br>\n🔹 <strong>Provenienza garantita</strong> da allevamenti controllati, destinati alla produzione del prosciutto di Parma.</p>\n<h3>Caratteristiche:</h3>\n<p>✔️ <strong>Prodotto ad alta densità, media durezza, media elasticità e alta appetibilità (per la presenza di grasso essiccato)</strong><br>\n✔️ <strong>Doppia consistenza:</strong></p>\n<ul>\n<li><strong>Parte esterna</strong> più dura, per una masticazione prolungata, che si ammorbidisce con la saliva.</li>\n<li><strong>Parte interna</strong> morbida e arricchita di grasso altamente appetibile.</li>\n</ul>\n<p>✔️ <strong>Benefici nutrizionali:</strong></p>\n<ul>\n<li>Fonte di energia</li>\n<li>Ricco di proteine, vitamine del gruppo B e sali minerali</li>\n</ul>\n<p>⚠️ <strong>Non adatto a cani in sovrappeso.</strong></p>\n",
    "name": "Cotenna di Suino",
    "slug": "cotenna",
    "specs": "<p>🔬 <strong>Analisi nutrizionale</strong> (valori in g per 100 g):</p>\n<ul>\n<li><strong>Umidità</strong>: 1,42 g <em>(Rapporti ISTISAN 1996/34 pag.7 Met. B ± 0,2)</em></li>\n<li><strong>Sostanze grasse totali</strong>: 39,1 g <em>(MP/C/071 rev3 06/20 ± 0,29)</em></li>\n<li><strong>Sostanze azotate totali (Proteine)</strong>: 56,9 g <em>(MP/C/057 rev5 06/20 ± 0,40)</em></li>\n<li><strong>Ceneri</strong>: 0,790 g <em>(MP/C/056 rev3 06/20 ± 0,40)</em></li>\n<li><strong>Fibra</strong>: 0,79 g <em>(AACC method 32-10.01)</em></li>\n</ul>\n",
    "Tipo": "Suino",
    "Order": 17,
    "isComingSoon": false,
    "locale": "it",
    "published_at": "2025-01-24T20:42:23.202Z",
    "created_at": "2025-01-24T20:42:21.053Z",
    "updated_at": "2025-07-14T07:37:50.470Z",
    "img": {
      "id": 46,
      "name": "Cotenna v1.jpg",
      "alternativeText": "",
      "caption": "",
      "width": 1600,
      "height": 1600,
      "formats": {
        "thumbnail": {
          "name": "thumbnail_Cotenna v1.jpg",
          "hash": "thumbnail_Cotenna_v1_c68f730256",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 156,
          "height": 156,
          "size": 4.2,
          "path": null,
          "url": "/uploads/thumbnail_Cotenna_v1_c68f730256.jpg"
        },
        "large": {
          "name": "large_Cotenna v1.jpg",
          "hash": "large_Cotenna_v1_c68f730256",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 1000,
          "height": 1000,
          "size": 82.8,
          "path": null,
          "url": "/uploads/large_Cotenna_v1_c68f730256.jpg"
        },
        "medium": {
          "name": "medium_Cotenna v1.jpg",
          "hash": "medium_Cotenna_v1_c68f730256",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 750,
          "height": 750,
          "size": 51.44,
          "path": null,
          "url": "/uploads/medium_Cotenna_v1_c68f730256.jpg"
        },
        "small": {
          "name": "small_Cotenna v1.jpg",
          "hash": "small_Cotenna_v1_c68f730256",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 500,
          "height": 500,
          "size": 27.84,
          "path": null,
          "url": "/uploads/small_Cotenna_v1_c68f730256.jpg"
        }
      },
      "hash": "Cotenna_v1_c68f730256",
      "ext": ".jpg",
      "mime": "image/jpeg",
      "size": 162.09,
      "url": "/uploads/Cotenna_v1_c68f730256.jpg",
      "previewUrl": null,
      "provider": "local",
      "provider_metadata": null,
      "created_at": "2025-02-08T14:13:52.874Z",
      "updated_at": "2025-02-08T14:13:52.883Z"
    },
    "localizations": []
  },
  {
    "id": 5,
    "price": 25,
    "abstract": "<p>Masticativo eccezionale, altamente appetibile e digeribile.</p>\n",
    "description": "<p><strong>Masticativo eccezionale, altamente appetibile e digeribile di alta friabilità e durezza.</strong></p>\n<p>🔹 <strong>Fonte naturale di glucosamina</strong>, utile per il benessere articolare.<br>\n🔹 <strong>Provenienza garantita</strong> da allevamenti controllati, destinati alla produzione del prosciutto di Parma.</p>\n<h2>Benefici e utilizzo</h2>\n<p>✔️ <strong>Stimola la concentrazione e l’appagamento</strong> del cane.<br>\n✔️ <strong>Favorisce la detersione dei denti e la rimozione del tartaro</strong>, particolarmente indicato per cani adolescenti, adulti e anziani con dentatura completa.<br>\n✔️ Consigliati per differenti lavorazioni inerenti a: gestione di risorse e spazi, riduzione degli stati d'ansia e attività sul distacco.</p>\n<h2>📅 Modalità d’uso</h2>\n<p>👉 <strong>1-2 pezzi al giorno</strong> in base alle esigenze del cane.</p>\n<p>⚠️ <strong>Supervisionare sempre il cane durante la masticazione per un'esperienza sicura.</strong></p>\n",
    "name": "Orecchio di Suino",
    "slug": "orecchio",
    "specs": "<p>🔬 <strong>Analisi nutrizionale</strong> (valori in g per 100 g):</p>\n<ul>\n<li><strong>Umidità</strong>: 9,34 g <em>(Rapporti ISTISAN 1996/34 pag.7 Met. B ± 0,2)</em></li>\n<li><strong>Sostanze grasse totali</strong>: 11,3 g <em>(MP/C/071 rev3 06/20 ± 0,30)</em></li>\n<li><strong>Sostanze azotate totali (Proteine)</strong>: 68,8 g <em>(MP/C/057 rev5 06/20 ± 0,40)</em></li>\n<li><strong>Ceneri</strong>: 1,08 g <em>(MP/C/056 rev3 06/20 ± 0,040)</em></li>\n<li><strong>Fibra</strong>: 0,58 g <em>(AACC method 32-10.01)</em></li>\n</ul>\n",
    "Tipo": "Suino",
    "Order": 13,
    "isComingSoon": false,
    "locale": "it",
    "published_at": "2025-01-24T20:43:05.550Z",
    "created_at": "2025-01-24T20:43:03.248Z",
    "updated_at": "2025-07-14T07:36:42.895Z",
    "img": {
      "id": 52,
      "name": "Orecchio v1.jpg",
      "alternativeText": "",
      "caption": "",
      "width": 1600,
      "height": 1600,
      "formats": {
        "thumbnail": {
          "name": "thumbnail_Orecchio v1.jpg",
          "hash": "thumbnail_Orecchio_v1_bb9125318e",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 156,
          "height": 156,
          "size": 3.93,
          "path": null,
          "url": "/uploads/thumbnail_Orecchio_v1_bb9125318e.jpg"
        },
        "large": {
          "name": "large_Orecchio v1.jpg",
          "hash": "large_Orecchio_v1_bb9125318e",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 1000,
          "height": 1000,
          "size": 78.86,
          "path": null,
          "url": "/uploads/large_Orecchio_v1_bb9125318e.jpg"
        },
        "medium": {
          "name": "medium_Orecchio v1.jpg",
          "hash": "medium_Orecchio_v1_bb9125318e",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 750,
          "height": 750,
          "size": 48.34,
          "path": null,
          "url": "/uploads/medium_Orecchio_v1_bb9125318e.jpg"
        },
        "small": {
          "name": "small_Orecchio v1.jpg",
          "hash": "small_Orecchio_v1_bb9125318e",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 500,
          "height": 500,
          "size": 25.47,
          "path": null,
          "url": "/uploads/small_Orecchio_v1_bb9125318e.jpg"
        }
      },
      "hash": "Orecchio_v1_bb9125318e",
      "ext": ".jpg",
      "mime": "image/jpeg",
      "size": 157.07,
      "url": "/uploads/Orecchio_v1_bb9125318e.jpg",
      "previewUrl": null,
      "provider": "local",
      "provider_metadata": null,
      "created_at": "2025-02-08T14:13:53.962Z",
      "updated_at": "2025-02-08T14:13:53.971Z"
    },
    "localizations": []
  },
  {
    "id": 13,
    "price": 20,
    "abstract": "<p>Masticativo altamente proteico, ideale anche per cani sportivi.</p>\n",
    "description": "<p><strong>Masticativo altamente proteico, ideale anche per cani sportivi, prodotto di alta durezza e bassa friabilità.</strong></p>\n<p>🔹 <strong>Alta appetibilità</strong>, perfetto per cani che svolgono <strong>attività fisica intensa</strong>.<br>\n🔹 <strong>Composizione:</strong> circa <strong>90% di proteine</strong>, <strong>alto valore biologico</strong>, energia immediata e <strong>privo di grassi</strong>.</p>\n<h2>Benefici e utilizzo</h2>\n<p>✔️ <strong>Potente fonte energetica</strong>, da usare con moderazione.<br>\n✔️ <strong>Somministrazione consigliata:</strong> occasionalmente, in base alle esigenze del cane.</p>\n<h2>⚠️ Avvertenze</h2>\n<p>⚠️ <strong>&quot;Bomba energetica&quot;</strong> – da utilizzare con moderazione.<br>\n⚠️ <strong>Uso quotidiano:</strong> consultare un veterinario per garantire un bilanciamento ottimale della dieta.</p>\n",
    "name": "Cuore di Bovino",
    "slug": "cuore",
    "specs": "<p>🔬 <strong>Analisi nutrizionale</strong> (valori in g per 100 g):</p>\n<ul>\n<li><strong>Umidità</strong>: 9,85 g <em>(Rapporti ISTISAN 1996/34 pag.7 Met. B ± 0,2)</em></li>\n<li><strong>Sostanze grasse totali</strong>: 23,1 g <em>(MP/C/071 rev3 06/20 ± 0,29)</em></li>\n<li><strong>Sostanze azotate totali (Proteine)</strong>: 61,2 g <em>(MP/C/057 rev5 06/20 ± 0,40)</em></li>\n<li><strong>Ceneri</strong>: 5,02 g <em>(MP/C/056 rev3 06/20 ± 0,050)</em></li>\n<li><strong>Fibra</strong>: 0,65 g <em>(AACC method 32-10.01)</em></li>\n</ul>\n",
    "Tipo": "Bovino",
    "Order": 6,
    "isComingSoon": false,
    "locale": "it",
    "published_at": "2025-02-08T09:07:41.464Z",
    "created_at": "2025-02-08T09:07:38.330Z",
    "updated_at": "2025-07-14T07:34:46.756Z",
    "img": {
      "id": 49,
      "name": "Cuore v1.jpg",
      "alternativeText": "",
      "caption": "",
      "width": 1600,
      "height": 1600,
      "formats": {
        "thumbnail": {
          "name": "thumbnail_Cuore v1.jpg",
          "hash": "thumbnail_Cuore_v1_db62a8dcdd",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 156,
          "height": 156,
          "size": 4.18,
          "path": null,
          "url": "/uploads/thumbnail_Cuore_v1_db62a8dcdd.jpg"
        },
        "large": {
          "name": "large_Cuore v1.jpg",
          "hash": "large_Cuore_v1_db62a8dcdd",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 1000,
          "height": 1000,
          "size": 113.13,
          "path": null,
          "url": "/uploads/large_Cuore_v1_db62a8dcdd.jpg"
        },
        "medium": {
          "name": "medium_Cuore v1.jpg",
          "hash": "medium_Cuore_v1_db62a8dcdd",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 750,
          "height": 750,
          "size": 68.11,
          "path": null,
          "url": "/uploads/medium_Cuore_v1_db62a8dcdd.jpg"
        },
        "small": {
          "name": "small_Cuore v1.jpg",
          "hash": "small_Cuore_v1_db62a8dcdd",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 500,
          "height": 500,
          "size": 34.5,
          "path": null,
          "url": "/uploads/small_Cuore_v1_db62a8dcdd.jpg"
        }
      },
      "hash": "Cuore_v1_db62a8dcdd",
      "ext": ".jpg",
      "mime": "image/jpeg",
      "size": 223.35,
      "url": "/uploads/Cuore_v1_db62a8dcdd.jpg",
      "previewUrl": null,
      "provider": "local",
      "provider_metadata": null,
      "created_at": "2025-02-08T14:13:52.930Z",
      "updated_at": "2025-02-08T14:13:52.938Z"
    },
    "localizations": []
  },
  {
    "id": 15,
    "price": 18,
    "abstract": "<p>Masticativo altamente appetibile e profumato, ideale per attività di ricerca e collaborazione.</p>\n",
    "description": "<p><strong>Masticativo altamente appetibile e profumato, ideale per attività di ricerca e collaborazione.</strong></p>\n<p>🔹 Fare attenzione con cuccioli in fase di cambio di dentizione<br>\n🔹 <strong>Profumo intenso</strong>, che aumenta lasciandolo in ammollo in acqua per 10 minuti.<br>\n🔹 Perfetto per <strong>tracce, dummy training e lavori che richiedono alta motivazione.</strong></p>\n<h2>Benefici e utilizzo</h2>\n<p>✔️ <strong>Adatto per tutti i cani</strong>, ma da usare in piccole quantità e con moderazione.<br>\n✔️ <strong>Dosaggio consigliato:</strong></p>\n<ul>\n<li><strong>Uso quotidiano:</strong> massimo <strong>10 g per un cane di 25 kg quando non fà attività di apprendimento</strong>.</li>\n<li><strong>Sessioni di lavoro:</strong> <strong>100-150 g per un cane di 25 kg</strong>, seguiti da <strong>2-3 giorni di pausa</strong>.</li>\n</ul>\n<h2>⚠️ Avvertenze</h2>\n<p>⚠️ <strong>Uso eccessivo può causare disturbi intestinali</strong>, come <strong>dissenteria e flatulenza</strong>.<br>\n⚠️ <strong>Adatto a tutti i cani, ma va somministrato con attenzione per evitare effetti indesiderati.</strong><br>\n⚠️ <strong>N.B.</strong> l'apparato gastroenterico è il secondo cervello di qualunque mammifero, occhio a non sollecitarlo troppo.</p>\n",
    "name": "Fegato di Bovino",
    "slug": "fegato",
    "specs": "<p>🔬 <strong>Analisi nutrizionale</strong> (valori in g per 100 g):</p>\n<ul>\n<li><strong>Umidità</strong>: 4,97 g <em>(Rapporti ISTISAN 1996/34 pag.7 Met. B ± 0,2)</em></li>\n<li><strong>Sostanze grasse totali</strong>: 23,1 g <em>(MP/C/071 rev3 06/20 ± 0,29)</em></li>\n<li><strong>Sostanze azotate totali (Proteine)</strong>: 64,5 g <em>(MP/C/057 rev5 06/20 ± 0,40)</em></li>\n<li><strong>Ceneri</strong>: 6,63 g <em>(MP/C/056 rev3 06/20 ± 0,050)</em></li>\n<li><strong>Fibra</strong>: 0,68 g <em>(AACC method 32-10.01)</em></li>\n</ul>\n",
    "Tipo": "Bovino",
    "Order": 7,
    "isComingSoon": false,
    "locale": "it",
    "published_at": "2025-02-08T11:37:48.700Z",
    "created_at": "2025-02-08T11:37:45.374Z",
    "updated_at": "2025-07-14T07:34:52.628Z",
    "img": {
      "id": 48,
      "name": "Fegato v1.jpg",
      "alternativeText": "",
      "caption": "",
      "width": 1600,
      "height": 1600,
      "formats": {
        "thumbnail": {
          "name": "thumbnail_Fegato v1.jpg",
          "hash": "thumbnail_Fegato_v1_5376ff9fd0",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 156,
          "height": 156,
          "size": 3.17,
          "path": null,
          "url": "/uploads/thumbnail_Fegato_v1_5376ff9fd0.jpg"
        },
        "large": {
          "name": "large_Fegato v1.jpg",
          "hash": "large_Fegato_v1_5376ff9fd0",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 1000,
          "height": 1000,
          "size": 69.07,
          "path": null,
          "url": "/uploads/large_Fegato_v1_5376ff9fd0.jpg"
        },
        "medium": {
          "name": "medium_Fegato v1.jpg",
          "hash": "medium_Fegato_v1_5376ff9fd0",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 750,
          "height": 750,
          "size": 42.32,
          "path": null,
          "url": "/uploads/medium_Fegato_v1_5376ff9fd0.jpg"
        },
        "small": {
          "name": "small_Fegato v1.jpg",
          "hash": "small_Fegato_v1_5376ff9fd0",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 500,
          "height": 500,
          "size": 22.36,
          "path": null,
          "url": "/uploads/small_Fegato_v1_5376ff9fd0.jpg"
        }
      },
      "hash": "Fegato_v1_5376ff9fd0",
      "ext": ".jpg",
      "mime": "image/jpeg",
      "size": 135.12,
      "url": "/uploads/Fegato_v1_5376ff9fd0.jpg",
      "previewUrl": null,
      "provider": "local",
      "provider_metadata": null,
      "created_at": "2025-02-08T14:13:52.913Z",
      "updated_at": "2025-02-08T14:13:52.921Z"
    },
    "localizations": []
  },
  {
    "id": 16,
    "price": 23,
    "abstract": "<p>Carne essicata, non trattata né modificata – senza conservati e/o aggiunte artificiali.</p>\n",
    "description": "<p><strong>Carne essicata, non trattata né modificata – senza conservati e/o aggiunte artificiali.</strong></p>\n<p>🔹 <strong>Prodotto esclusivo</strong>,  studiato per differenti attività di apprendimento, si presenta in varie forme: fettine o pezzi naturali con grasso.<br>\n🔹 <strong>Altissima appetibilità</strong>, eccellente per cani <strong>pigri, sensibili, reattivi e diffidenti</strong>.<br>\n🔹 <strong>Ideale per attività di problem solving, mobility, giochi cognitivi, scatola cognitiva e attività di predazione.</strong><br>\n🔹 <strong>Provenienza garantita</strong> da allevamenti controllati, destinati alla produzione del prosciutto di Parma.<br>\n🔹 <strong>Prodotto consigliato per attività di recupero</strong> su cani con fobia traumatiche ed ontogenetiche.</p>\n<h2>Benefici e utilizzo</h2>\n<p>✔️ <strong>Masticativo altamente appetibile e appagante, di facile consumazione.</strong><br>\n✔️ <strong>Eccellente prodotto per creare un alta collaborazione, aumento dei tempi di attenzione e di concentrazione nel cane</strong>, dando così al tecnico di riferimento uno strumento funzionale per le sessioni di lavoro.<br>\n✔️ <strong>Somministrazione:</strong> più volte al giorno in base alle necessità del cane.</p>\n<h2>⚠️ Avvertenze</h2>\n<p>⚠️ <strong>Chiedere al veterinario per l'utilizzo con cani in sovrappeso.</strong></p>\n",
    "name": "Carne di Suino",
    "slug": "maiale",
    "specs": "<p>🔬 <strong>Analisi nutrizionale</strong> (valori in g per 100 g):</p>\n<ul>\n<li><strong>Umidità</strong>: 5,57 g <em>(Rapporti ISTISAN 1996/34 pag.7 Met. B ± 0,2)</em></li>\n<li><strong>Sostanze grasse totali</strong>: 9,21 g <em>(MP/C/071 rev3 06/20 ± 0,28)</em></li>\n<li><strong>Sostanze azotate totali (Proteine)</strong>: 79,6 g <em>(MP/C/057 rev5 06/20 ± 0,40)</em></li>\n<li><strong>Ceneri</strong>: 4,44 g <em>(MP/C/056 rev3 06/20 ± 0,050)</em></li>\n<li><strong>Fibra</strong>: 0,92 g <em>(AACC method 32-10.01)</em></li>\n</ul>\n",
    "Tipo": "Suino",
    "Order": 18,
    "isComingSoon": false,
    "locale": "it",
    "published_at": "2025-02-08T11:38:26.175Z",
    "created_at": "2025-02-08T11:38:23.048Z",
    "updated_at": "2025-07-14T07:37:40.374Z",
    "img": {
      "id": 51,
      "name": "Maiale v1.jpg",
      "alternativeText": "",
      "caption": "",
      "width": 1600,
      "height": 1600,
      "formats": {
        "thumbnail": {
          "name": "thumbnail_Maiale v1.jpg",
          "hash": "thumbnail_Maiale_v1_e657449a97",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 156,
          "height": 156,
          "size": 4.54,
          "path": null,
          "url": "/uploads/thumbnail_Maiale_v1_e657449a97.jpg"
        },
        "large": {
          "name": "large_Maiale v1.jpg",
          "hash": "large_Maiale_v1_e657449a97",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 1000,
          "height": 1000,
          "size": 112.21,
          "path": null,
          "url": "/uploads/large_Maiale_v1_e657449a97.jpg"
        },
        "medium": {
          "name": "medium_Maiale v1.jpg",
          "hash": "medium_Maiale_v1_e657449a97",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 750,
          "height": 750,
          "size": 66.47,
          "path": null,
          "url": "/uploads/medium_Maiale_v1_e657449a97.jpg"
        },
        "small": {
          "name": "small_Maiale v1.jpg",
          "hash": "small_Maiale_v1_e657449a97",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 500,
          "height": 500,
          "size": 33.95,
          "path": null,
          "url": "/uploads/small_Maiale_v1_e657449a97.jpg"
        }
      },
      "hash": "Maiale_v1_e657449a97",
      "ext": ".jpg",
      "mime": "image/jpeg",
      "size": 234.74,
      "url": "/uploads/Maiale_v1_e657449a97.jpg",
      "previewUrl": null,
      "provider": "local",
      "provider_metadata": null,
      "created_at": "2025-02-08T14:13:53.174Z",
      "updated_at": "2025-02-08T14:13:53.181Z"
    },
    "localizations": []
  },
  {
    "id": 17,
    "price": 15,
    "abstract": "<p>Masticativo eccellente con consistenza morbida e leggermente elastica.</p>\n",
    "description": "<p><strong>Masticativo eccellente con consistenza elastica, di media durezza e morbida nella zona grassa.</strong></p>\n<p>🔹 <strong>Altissima appetibilità e grado di appagamento.</strong><br>\n🔹 <strong>Peso variabile dai 40 g a oltre 100 g</strong>, prestare attenzione alla taglia del cane.<br>\n🔹 <strong>Particolarmente indicato per cani con intolleranze alimentari.</strong><br>\n🔹 <strong>Provenienza garantita</strong> da allevamenti controllati, destinati alla produzione del prosciutto di Parma.</p>\n<h2>Benefici e utilizzo</h2>\n<p>✔️ <strong>Adatto a tutte le taglie e tipologie di cani</strong>, a partire dai <strong>5 mesi di età</strong>.<br>\n✔️ <strong>Consistenza bilanciata</strong>: morbida grazie alla presenza di grasso, ma leggermente elastica per una masticazione soddisfacente.</p>\n<h2>⚠️ Conservazione</h2>\n<p>❄️ <strong>Data l’elevata presenza di grasso, conservare in freezer dopo l’apertura.</strong></p>\n",
    "name": "Padiglioni di Suino",
    "slug": "padiglioni",
    "specs": "<p>🔬 <strong>Analisi nutrizionale</strong> (valori in g per 100 g):</p>\n<ul>\n<li><strong>Umidità</strong>: 10,6 g <em>(Rapporti ISTISAN 1996/34 pag.7 Met. B ± 0,2)</em></li>\n<li><strong>Sostanze grasse totali</strong>: 45,2 g <em>(MP/C/071 rev3 06/20 ± 0,29)</em></li>\n<li><strong>Sostanze azotate totali (Proteine)</strong>: 25,0 g <em>(MP/C/057 rev5 06/20 ± 0,40)</em></li>\n<li><strong>Ceneri</strong>: 10,2 g <em>(MP/C/056 rev3 06/20 ± 0,050)</em></li>\n<li><strong>Fibra</strong>: 1,01 g <em>(AACC method 32-10.01)</em></li>\n</ul>\n",
    "Tipo": "Suino",
    "Order": 14,
    "isComingSoon": false,
    "locale": "it",
    "published_at": "2025-02-08T11:39:21.973Z",
    "created_at": "2025-02-08T11:39:09.946Z",
    "updated_at": "2025-07-14T07:38:47.086Z",
    "img": {
      "id": 53,
      "name": "Padiglioni v1.jpg",
      "alternativeText": "",
      "caption": "",
      "width": 1600,
      "height": 1600,
      "formats": {
        "thumbnail": {
          "name": "thumbnail_Padiglioni v1.jpg",
          "hash": "thumbnail_Padiglioni_v1_4a7af42942",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 156,
          "height": 156,
          "size": 4.32,
          "path": null,
          "url": "/uploads/thumbnail_Padiglioni_v1_4a7af42942.jpg"
        },
        "large": {
          "name": "large_Padiglioni v1.jpg",
          "hash": "large_Padiglioni_v1_4a7af42942",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 1000,
          "height": 1000,
          "size": 98.2,
          "path": null,
          "url": "/uploads/large_Padiglioni_v1_4a7af42942.jpg"
        },
        "medium": {
          "name": "medium_Padiglioni v1.jpg",
          "hash": "medium_Padiglioni_v1_4a7af42942",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 750,
          "height": 750,
          "size": 59.6,
          "path": null,
          "url": "/uploads/medium_Padiglioni_v1_4a7af42942.jpg"
        },
        "small": {
          "name": "small_Padiglioni v1.jpg",
          "hash": "small_Padiglioni_v1_4a7af42942",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 500,
          "height": 500,
          "size": 30.83,
          "path": null,
          "url": "/uploads/small_Padiglioni_v1_4a7af42942.jpg"
        }
      },
      "hash": "Padiglioni_v1_4a7af42942",
      "ext": ".jpg",
      "mime": "image/jpeg",
      "size": 194.63,
      "url": "/uploads/Padiglioni_v1_4a7af42942.jpg",
      "previewUrl": null,
      "provider": "local",
      "provider_metadata": null,
      "created_at": "2025-02-08T14:13:53.982Z",
      "updated_at": "2025-02-08T14:13:53.990Z"
    },
    "localizations": []
  },
  {
    "id": 18,
    "price": 20,
    "abstract": "<p>Adatto a cani di tutte le età e taglie</p>\n",
    "description": "<p><strong>Adatto a cani di tutte le età e taglie.</strong></p>\n<p>🔹 <strong>Ideale per cuccioli, cani inesperti, cani ansiosi e cani anziani</strong> che iniziano una primo approccio alla masticazione.<br>\n🔹 <strong>Altamente friabile, di bassa durezza e alta digeribilità</strong>, oltre che per i cuccioli è altamente indicato per cani in sovrappeso.</p>\n<h2>Benefici e utilizzo</h2>\n<p>✔️ <strong>Indicato per cani con alto disagio sociale e ambientale e presenza di stati ansiosi</strong>, vista la sua bassa durezza e alta friabilità (prodotto molto tenero).<br>\n✔️ <strong>Facile da masticare</strong>, perfetto anche per chi ha una dentatura delicata.<br>\n✔️ <strong>Alta digeribilità</strong>, può essere somministrato a tutte le età e più volte al giorno.</p>\n",
    "name": "Polmone di Bovino",
    "slug": "polmone",
    "specs": "<p>🔬 <strong>Analisi nutrizionale</strong> (valori in g per 100 g):</p>\n<ul>\n<li><strong>Umidità</strong>: 8,16 g <em>(Rapporti ISTISAN 1996/34 pag.7 Met. B ± 0,2)</em></li>\n<li><strong>Sostanze grasse totali</strong>: 7,35 g <em>(MP/C/071 rev3 06/20 ± 0,28)</em></li>\n<li><strong>Sostanze azotate totali (Proteine)</strong>: 77,3 g <em>(MP/C/057 rev5 06/20 ± 0,40)</em></li>\n<li><strong>Ceneri</strong>: 6,58 g <em>(MP/C/056 rev3 06/20 ± 0,050)</em></li>\n<li><strong>Fibra</strong>: 0,29 g <em>(AACC method 32-10.01)</em></li>\n</ul>\n",
    "Tipo": "Bovino",
    "Order": 5,
    "isComingSoon": false,
    "locale": "it",
    "published_at": "2025-02-08T11:39:55.711Z",
    "created_at": "2025-02-08T11:39:52.492Z",
    "updated_at": "2025-07-14T07:34:40.363Z",
    "img": {
      "id": 54,
      "name": "Polmone v1.jpg",
      "alternativeText": "",
      "caption": "",
      "width": 1600,
      "height": 1600,
      "formats": {
        "thumbnail": {
          "name": "thumbnail_Polmone v1.jpg",
          "hash": "thumbnail_Polmone_v1_77f7e9b760",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 156,
          "height": 156,
          "size": 4.34,
          "path": null,
          "url": "/uploads/thumbnail_Polmone_v1_77f7e9b760.jpg"
        },
        "large": {
          "name": "large_Polmone v1.jpg",
          "hash": "large_Polmone_v1_77f7e9b760",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 1000,
          "height": 1000,
          "size": 107.75,
          "path": null,
          "url": "/uploads/large_Polmone_v1_77f7e9b760.jpg"
        },
        "medium": {
          "name": "medium_Polmone v1.jpg",
          "hash": "medium_Polmone_v1_77f7e9b760",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 750,
          "height": 750,
          "size": 66.01,
          "path": null,
          "url": "/uploads/medium_Polmone_v1_77f7e9b760.jpg"
        },
        "small": {
          "name": "small_Polmone v1.jpg",
          "hash": "small_Polmone_v1_77f7e9b760",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 500,
          "height": 500,
          "size": 34.36,
          "path": null,
          "url": "/uploads/small_Polmone_v1_77f7e9b760.jpg"
        }
      },
      "hash": "Polmone_v1_77f7e9b760",
      "ext": ".jpg",
      "mime": "image/jpeg",
      "size": 209.51,
      "url": "/uploads/Polmone_v1_77f7e9b760.jpg",
      "previewUrl": null,
      "provider": "local",
      "provider_metadata": null,
      "created_at": "2025-02-08T14:13:53.999Z",
      "updated_at": "2025-02-08T14:13:54.006Z"
    },
    "localizations": []
  },
  {
    "id": 19,
    "price": 18,
    "abstract": "<p><strong>(tagliata a mano circa 15-25cm)</strong> Adatto a tutti i cani con una buona capacità masticatoria.</p>\n",
    "description": "<p><strong>Tagliata a mano circa  15/25 cm, adatto a tutti i cani con una buona capacità masticatoria.</strong></p>\n<p>🔹 <strong>Adatto a cani sopra i 2 anni, da taglia &quot;grande&quot; (50kg) in su</strong></p>\n<h2>Benefici e utilizzo</h2>\n<p>✔️ <strong>Buona digeribilità</strong><br>\n✔️ <strong>Per cani da taglia grande(50kg)</strong>, può essere somministrato <strong>un paio di volte a settimana</strong> in base alle necessità del cane.<br>\n✔️ <strong>Per cani da taglia grande (50kg) in su</strong>, può essere somministrato <strong>2 volte a settimana</strong> in base alle necessità del cane.<br>\n✔️ Consigliato per attività di predazione, di riduzione degli indici di stress, di distacco, di supporto a problematiche di separazione e con cani competenti, ottimo prodotto per lavorare sulle fasi di calma in attività di socializzazione intraspecifica di gruppo</p>\n<h2>⚠️ Attenzione ai soggetti voraci</h2>\n<ul>\n<li>Fare attenzione alle quantità somministrate, ogni trachea ha un peso variabile dai 100g a oltre i 300g</li>\n<li>Ingestioni rapide potrebbero causare <strong>lievi irritazioni alla trachea</strong>.</li>\n</ul>\n<p>👉 <strong>Supervisionare sempre il cane durante la masticazione per un'esperienza sicura.</strong></p>\n",
    "name": "Trachea di Bovino Lunga",
    "slug": "trachea-l",
    "specs": "<p>🔬 <strong>Analisi nutrizionale</strong> (valori in g per 100 g):</p>\n<ul>\n<li><strong>Umidità</strong>: 10,1 g <em>(Rapporti ISTISAN 1996/34 pag.7 Met. B ± 0,2)</em></li>\n<li><strong>Sostanze grasse totali</strong>: 25,1 g <em>(MP/C/071 rev3 06/20 ± 0,29)</em></li>\n<li><strong>Sostanze azotate totali (Proteine)</strong>: 53,6 g <em>(MP/C/057 rev5 06/20 ± 0,40)</em></li>\n<li><strong>Ceneri</strong>: 10,3 g <em>(MP/C/056 rev3 06/20 ± 0,050)</em></li>\n<li><strong>Fibra</strong>: 0,87 g <em>(AACC method 32-10.01)</em></li>\n</ul>\n",
    "Tipo": "Bovino",
    "Order": 4,
    "isComingSoon": false,
    "locale": "it",
    "published_at": "2025-02-08T11:40:38.381Z",
    "created_at": "2025-02-08T11:40:34.802Z",
    "updated_at": "2025-07-14T07:34:01.658Z",
    "img": {
      "id": 55,
      "name": "Trachea Lunga v1.jpg",
      "alternativeText": "",
      "caption": "",
      "width": 1600,
      "height": 1600,
      "formats": {
        "thumbnail": {
          "name": "thumbnail_Trachea Lunga v1.jpg",
          "hash": "thumbnail_Trachea_Lunga_v1_1912609888",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 156,
          "height": 156,
          "size": 4.68,
          "path": null,
          "url": "/uploads/thumbnail_Trachea_Lunga_v1_1912609888.jpg"
        },
        "large": {
          "name": "large_Trachea Lunga v1.jpg",
          "hash": "large_Trachea_Lunga_v1_1912609888",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 1000,
          "height": 1000,
          "size": 113.49,
          "path": null,
          "url": "/uploads/large_Trachea_Lunga_v1_1912609888.jpg"
        },
        "medium": {
          "name": "medium_Trachea Lunga v1.jpg",
          "hash": "medium_Trachea_Lunga_v1_1912609888",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 750,
          "height": 750,
          "size": 69.27,
          "path": null,
          "url": "/uploads/medium_Trachea_Lunga_v1_1912609888.jpg"
        },
        "small": {
          "name": "small_Trachea Lunga v1.jpg",
          "hash": "small_Trachea_Lunga_v1_1912609888",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 500,
          "height": 500,
          "size": 35.92,
          "path": null,
          "url": "/uploads/small_Trachea_Lunga_v1_1912609888.jpg"
        }
      },
      "hash": "Trachea_Lunga_v1_1912609888",
      "ext": ".jpg",
      "mime": "image/jpeg",
      "size": 222.75,
      "url": "/uploads/Trachea_Lunga_v1_1912609888.jpg",
      "previewUrl": null,
      "provider": "local",
      "provider_metadata": null,
      "created_at": "2025-02-08T14:13:54.016Z",
      "updated_at": "2025-02-27T14:19:48.207Z"
    },
    "localizations": []
  },
  {
    "id": 20,
    "price": 18,
    "abstract": "<p><strong>(tagliata a mano circa 6-12cm)</strong> Adatto a tutti i cani con una buona capacità masticatoria.</p>\n",
    "description": "<p><strong>Tagliata a mano circa  6/12 cm, adatto a tutti i cani con una buona capacità masticatoria.</strong></p>\n<p>🔹 <strong>Adatto anche a cani sopra i 6 mesi, da taglia &quot;media&quot; (15kg) in su</strong></p>\n<h2>Benefici e utilizzo</h2>\n<p>✔️ <strong>Buona digeribilità</strong>, può essere somministrato <strong>2-3 volte al giorno</strong> in base alle necessità del cane.<br>\n✔️ <strong>Ottimo prodotto</strong> per lavorare sulla riduzione degli indici di stress, sulla gestione delle risorse, sulla riduzione della competitività, sulla socializzazione inter e intra specifica e in attività inerenti il distacco.</p>\n<h2>⚠️ Attenzione ai soggetti voraci</h2>\n<ul>\n<li>Ingestioni rapide potrebbero causare <strong>lievi irritazioni alla trachea</strong>.</li>\n</ul>\n<p>👉 <strong>Supervisionare sempre il cane durante la masticazione per un'esperienza sicura.</strong></p>\n",
    "name": "Trachea di Bovino Media",
    "slug": "trachea-m",
    "specs": "<p>🔬 <strong>Analisi nutrizionale</strong> (valori in g per 100 g):</p>\n<ul>\n<li><strong>Umidità</strong>: 9,92 g <em>(Rapporti ISTISAN 1996/34 pag.7 Met. B ± 0,2)</em></li>\n<li><strong>Sostanze grasse totali</strong>: 24,6 g <em>(MP/C/071 rev3 06/20 ± 0,29)</em></li>\n<li><strong>Sostanze azotate totali (Proteine)</strong>: 52,4 g <em>(MP/C/057 rev5 06/20 ± 0,40)</em></li>\n<li><strong>Ceneri</strong>: 11,2 g <em>(MP/C/056 rev3 06/20 ± 0,050)</em></li>\n<li><strong>Fibra</strong>: 0,94 g <em>(AACC method 32-10.01)</em></li>\n</ul>\n",
    "Tipo": "Bovino",
    "Order": 3,
    "isComingSoon": false,
    "locale": "it",
    "published_at": "2025-02-08T11:41:08.029Z",
    "created_at": "2025-02-08T11:41:04.127Z",
    "updated_at": "2025-07-14T07:33:40.042Z",
    "img": {
      "id": 56,
      "name": "Trachea Media v1.jpg",
      "alternativeText": "",
      "caption": "",
      "width": 1600,
      "height": 1600,
      "formats": {
        "thumbnail": {
          "name": "thumbnail_Trachea Media v1.jpg",
          "hash": "thumbnail_Trachea_Media_v1_bf23e64621",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 156,
          "height": 156,
          "size": 4.57,
          "path": null,
          "url": "/uploads/thumbnail_Trachea_Media_v1_bf23e64621.jpg"
        },
        "large": {
          "name": "large_Trachea Media v1.jpg",
          "hash": "large_Trachea_Media_v1_bf23e64621",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 1000,
          "height": 1000,
          "size": 106.14,
          "path": null,
          "url": "/uploads/large_Trachea_Media_v1_bf23e64621.jpg"
        },
        "medium": {
          "name": "medium_Trachea Media v1.jpg",
          "hash": "medium_Trachea_Media_v1_bf23e64621",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 750,
          "height": 750,
          "size": 64.54,
          "path": null,
          "url": "/uploads/medium_Trachea_Media_v1_bf23e64621.jpg"
        },
        "small": {
          "name": "small_Trachea Media v1.jpg",
          "hash": "small_Trachea_Media_v1_bf23e64621",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 500,
          "height": 500,
          "size": 33.43,
          "path": null,
          "url": "/uploads/small_Trachea_Media_v1_bf23e64621.jpg"
        }
      },
      "hash": "Trachea_Media_v1_bf23e64621",
      "ext": ".jpg",
      "mime": "image/jpeg",
      "size": 209.2,
      "url": "/uploads/Trachea_Media_v1_bf23e64621.jpg",
      "previewUrl": null,
      "provider": "local",
      "provider_metadata": null,
      "created_at": "2025-02-08T14:13:54.070Z",
      "updated_at": "2025-02-08T14:13:54.076Z"
    },
    "localizations": []
  },
  {
    "id": 21,
    "price": 18,
    "abstract": "<p><strong>(tagliata a mano circa 2-5cm)</strong> Adatto a tutti i cani con una buona capacità masticatoria.</p>\n",
    "description": "<p><strong>Tagliata a mano circa 2/5 cm, adatto a tutti i cani con una buona capacità masticatoria.</strong></p>\n<p>🔹 <strong>Adatto anche ai cuccioli dai 3 mesi in su</strong>, con attenzione alla fase di cambio dei denti decidui.<br>\n🔹 <strong>In caso di perdita dei denti decidui</strong>, sospendere la somministrazione e riproporre il prodotto con il completamento della dentizione permanente, per evitare un utilizzo disfunzionale. Si consiglia di continuare le attività di masticaizone con prodotti teneri e friabili come polmone e maiale.</p>\n<h2>Benefici e utilizzo</h2>\n<p>✔️ <strong>Buona digeribilità</strong>, può essere somministrato <strong>2-3 volte al giorno</strong> in base alle necessità del cane.<br>\n✔️ Consigliato per la sua maggiore elasticità rispetto all'aorta per attività di riduzione degli indici di stress (anche lavori sul distacco e classi di comunicazione)</p>\n<h2>⚠️ Attenzione ai soggetti voraci</h2>\n<ul>\n<li>Per cani con tendenza a ingerire velocemente, si consiglia <strong>una pezzatura media o lunga</strong> anziché corta.</li>\n<li>Ingestioni rapide potrebbero causare <strong>lievi irritazioni alla trachea</strong>.</li>\n</ul>\n<p>👉 <strong>Supervisionare sempre il cane durante la masticazione per un'esperienza sicura.</strong></p>\n",
    "name": "Trachea di Bovino Corta",
    "slug": "trachea-s",
    "specs": "<p>🔬 <strong>Analisi nutrizionale</strong> (valori in g per 100 g):</p>\n<ul>\n<li><strong>Umidità</strong>: 9,54 g <em>(Rapporti ISTISAN 1996/34 pag.7 Met. B ± 0,2)</em></li>\n<li><strong>Sostanze grasse totali</strong>: 29,9 g <em>(MP/C/071 rev3 06/20 ± 0,29)</em></li>\n<li><strong>Sostanze azotate totali (Proteine)</strong>: 48,4 g <em>(MP/C/057 rev5 06/20 ± 0,40)</em></li>\n<li><strong>Ceneri</strong>: 10,4 g <em>(MP/C/056 rev3 06/20 ± 0,050)</em></li>\n<li><strong>Fibra</strong>: 0,94 g <em>(AACC method 32-10.01)</em></li>\n</ul>\n",
    "Tipo": "Bovino",
    "Order": 2,
    "isComingSoon": false,
    "locale": "it",
    "published_at": "2025-02-08T11:42:39.693Z",
    "created_at": "2025-02-08T11:41:35.085Z",
    "updated_at": "2025-07-14T07:33:34.278Z",
    "img": {
      "id": 45,
      "name": "Trachea Piccola v1.jpg",
      "alternativeText": "",
      "caption": "",
      "width": 1600,
      "height": 1600,
      "formats": {
        "thumbnail": {
          "name": "thumbnail_Trachea Piccola v1.jpg",
          "hash": "thumbnail_Trachea_Piccola_v1_1f100245e6",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 156,
          "height": 156,
          "size": 4.61,
          "path": null,
          "url": "/uploads/thumbnail_Trachea_Piccola_v1_1f100245e6.jpg"
        },
        "large": {
          "name": "large_Trachea Piccola v1.jpg",
          "hash": "large_Trachea_Piccola_v1_1f100245e6",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 1000,
          "height": 1000,
          "size": 112.07,
          "path": null,
          "url": "/uploads/large_Trachea_Piccola_v1_1f100245e6.jpg"
        },
        "medium": {
          "name": "medium_Trachea Piccola v1.jpg",
          "hash": "medium_Trachea_Piccola_v1_1f100245e6",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 750,
          "height": 750,
          "size": 66.78,
          "path": null,
          "url": "/uploads/medium_Trachea_Piccola_v1_1f100245e6.jpg"
        },
        "small": {
          "name": "small_Trachea Piccola v1.jpg",
          "hash": "small_Trachea_Piccola_v1_1f100245e6",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 500,
          "height": 500,
          "size": 34.11,
          "path": null,
          "url": "/uploads/small_Trachea_Piccola_v1_1f100245e6.jpg"
        }
      },
      "hash": "Trachea_Piccola_v1_1f100245e6",
      "ext": ".jpg",
      "mime": "image/jpeg",
      "size": 225.58,
      "url": "/uploads/Trachea_Piccola_v1_1f100245e6.jpg",
      "previewUrl": null,
      "provider": "local",
      "provider_metadata": null,
      "created_at": "2025-02-08T14:04:01.157Z",
      "updated_at": "2025-02-08T14:04:01.168Z"
    },
    "localizations": []
  },
  {
    "id": 22,
    "price": 20,
    "abstract": "<p>Tagliato a mano circa 10/20 cm. Masticativo impegnativo e di lunga durata con consistenza esterna molto più sostenuta dell'interna, il prodotto presenta un alta appetibilità.</p>\n",
    "description": "<p><strong>Tagliato a mano circa 10/20 cm. Masticativo impegnativo e di lunga durata con consistenza esterna molto più sostenuta dell'interna, il prodotto presenta un alta appetibilità.</strong></p>\n<p>🔹 <strong>Altamente appagante</strong> per il cane esperto in attività di masticazione<br>\n🔹 <strong>Adatto sia a cani adolescenti e adulti esperti</strong><br>\n🔹 <strong>Sconsigliato a cuccioli e cani anziani</strong></p>\n<h2>⚠️ Avvertenze</h2>\n<ul>\n<li>Si consiglia, alle prime somministrazioni, la supervisione durante l'attività masticatoria, poiché alcuni cani tendono a  ingerire rapidamente il prodotto, anche non correttamente masticato.</li>\n<li>È importante che un professionista valuti le capacità masticatorie del cane.</li>\n</ul>\n<h2>Frequenza e utilizzo consigliato</h2>\n<p>✔️ <strong>Cani fino a 15 kg:</strong> 1-2 volte a settimana<br>\n✔️ <strong>Cani dai 15 kg ai 30 kg in su:</strong> 2-4 volte a settimana<br>\n✔️ Consigliato in attività di recupero e defaticamento mentale nonchè in attività di lavorazione su problematiche di attaccamento e distacco.</p>\n<h2>⚠️ Digeribilità e precauzioni</h2>\n<ul>\n<li><strong>Bassa digeribilità:</strong> si raccomanda un uso moderato.</li>\n<li><strong>Dopo il consumo:</strong> evitare attività fisica intensa per permettere una corretta digestione.</li>\n<li><strong>Osservazioni:</strong> in alcuni soggetti, sono stati riscontrati frammenti non digeriti nelle feci.</li>\n<li><strong>Valutazione preventiva:</strong> è essenziale un'attenta analisi delle capacità masticatorie e delle condizioni digestive e intestinali del cane per evitare sovraccarichi organici, nel caso di soggetti non in buona salute chiedere consiglio al proprio veterinario prima del consumo.</li>\n</ul>\n",
    "name": "Nervo di Bovino Corto",
    "slug": "nervo-corto",
    "specs": "<p>🔬 <strong>Analisi nutrizionale</strong> (valori in g per 100 g):</p>\n<ul>\n<li><strong>Umidità</strong>: 8,47 g <em>(Rapporti ISTISAN 1996/34 pag.7 Met. B ± 0,2)</em></li>\n<li><strong>Sostanze grasse totali</strong>: 4,35 g <em>(MP/C/071 rev3 06/20 ± 0,20)</em></li>\n<li><strong>Sostanze azotate totali (Proteine)</strong>: 66,2 g <em>(MP/C/057 rev5 06/20 ± 0,40)</em></li>\n<li><strong>Ceneri</strong>: 3,67 g <em>(MP/C/056 rev3 06/20 ± 0,030)</em></li>\n<li><strong>Fibra</strong>: 1,14 g <em>(AACC method 32-10.01)</em></li>\n</ul>\n",
    "Tipo": "Bovino",
    "Order": 8,
    "isComingSoon": false,
    "locale": "it",
    "published_at": "2025-02-22T10:27:43.771Z",
    "created_at": "2025-02-16T17:41:15.905Z",
    "updated_at": "2025-07-14T07:34:59.244Z",
    "img": {
      "id": 63,
      "name": "Nervo Corto v1.jpg",
      "alternativeText": "",
      "caption": "",
      "width": 1600,
      "height": 1600,
      "formats": {
        "thumbnail": {
          "name": "thumbnail_Nervo Corto v1.jpg",
          "hash": "thumbnail_Nervo_Corto_v1_3fca693218",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 156,
          "height": 156,
          "size": 3.55,
          "path": null,
          "url": "/uploads/thumbnail_Nervo_Corto_v1_3fca693218.jpg"
        },
        "large": {
          "name": "large_Nervo Corto v1.jpg",
          "hash": "large_Nervo_Corto_v1_3fca693218",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 1000,
          "height": 1000,
          "size": 62.21,
          "path": null,
          "url": "/uploads/large_Nervo_Corto_v1_3fca693218.jpg"
        },
        "medium": {
          "name": "medium_Nervo Corto v1.jpg",
          "hash": "medium_Nervo_Corto_v1_3fca693218",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 750,
          "height": 750,
          "size": 39.79,
          "path": null,
          "url": "/uploads/medium_Nervo_Corto_v1_3fca693218.jpg"
        },
        "small": {
          "name": "small_Nervo Corto v1.jpg",
          "hash": "small_Nervo_Corto_v1_3fca693218",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 500,
          "height": 500,
          "size": 21.97,
          "path": null,
          "url": "/uploads/small_Nervo_Corto_v1_3fca693218.jpg"
        }
      },
      "hash": "Nervo_Corto_v1_3fca693218",
      "ext": ".jpg",
      "mime": "image/jpeg",
      "size": 117.3,
      "url": "/uploads/Nervo_Corto_v1_3fca693218.jpg",
      "previewUrl": null,
      "provider": "local",
      "provider_metadata": null,
      "created_at": "2025-04-19T09:38:14.477Z",
      "updated_at": "2025-04-19T09:38:14.484Z"
    },
    "localizations": []
  },
  {
    "id": 23,
    "price": 28,
    "abstract": "<p>Un'altra chicca nutrizionale: carne magra, ipoallergenica e ad alta digeribilità.</p>\n",
    "description": "<p><strong>Un'altra chicca nutrizionale: carne magra, ipoallergenica e ad alta digeribilità.</strong></p>\n<p>🔹 <strong>Parte utilizzata:</strong> muscolo.<br>\n🔹 <strong>Privo di grassi</strong>, fonte eccellente di proteine e ad alta digeribilità (assimilazione inizia in circa 40 minuti).<br>\n🔹 <strong>Prodotto ad alta densità e bassa durezza</strong>, di facile consumazione.</p>\n<h2>Benefici e utilizzo</h2>\n<p>✔️ <strong>Energia pronta all’uso</strong>, ideale per cani impegnati in <strong>trekking, competizioni o attività ad alto sforzo muscolare</strong>.<br>\n✔️ <strong>Perfetto per cani dinamici</strong>, che possono sfruttare al meglio l’energia immagazzinata.<br>\n✔️ <strong>Indicato per cani con restrizioni alimentari</strong>.<br>\n✔️ <strong>Somministrazione consigliata:</strong> 150 g per un cane di 25 kg, circa 1 ora prima dell’attività fisica.</p>\n<h2>⚠️ Avvertenze</h2>\n<ul>\n<li><strong>Uso quotidiano:</strong> se somministrato regolarmente, è consigliato consultare un veterinario per un bilanciamento ottimale della dieta.</li>\n</ul>\n",
    "name": "Carne di Cavallo",
    "slug": "cavallo",
    "specs": "<p>🔬 <strong>Analisi nutrizionale</strong> (valori in g per 100 g):</p>\n<ul>\n<li><strong>Umidità</strong>: 8,42 g <em>(Rapporti ISTISAN 1996/34 pag.7 Met. B ± 0,2)</em></li>\n<li><strong>Sostanze grasse totali</strong>: 8,09 g <em>(MP/C/071 rev3 06/20 ± 0,28)</em></li>\n<li><strong>Sostanze azotate totali (Proteine)</strong>: 77,4 g <em>(MP/C/057 rev5 06/20 ± 0,40)</em></li>\n<li><strong>Ceneri</strong>: 4,97 g <em>(MP/C/056 rev3 06/20 ± 0,050)</em></li>\n<li><strong>Fibra</strong>: 0,84 g <em>(AACC method 32-10.01)</em></li>\n</ul>\n",
    "Tipo": "Cavallo",
    "Order": 19,
    "isComingSoon": false,
    "locale": "it",
    "published_at": "2025-02-22T12:36:11.736Z",
    "created_at": "2025-02-22T10:15:41.029Z",
    "updated_at": "2025-07-14T07:37:30.582Z",
    "img": {
      "id": 58,
      "name": "Cavallo v1.jpg",
      "alternativeText": "",
      "caption": "",
      "width": 1600,
      "height": 1600,
      "formats": {
        "thumbnail": {
          "name": "thumbnail_Cavallo v1.jpg",
          "hash": "thumbnail_Cavallo_v1_aa6d5067d0",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 156,
          "height": 156,
          "size": 3.55,
          "path": null,
          "url": "/uploads/thumbnail_Cavallo_v1_aa6d5067d0.jpg"
        },
        "large": {
          "name": "large_Cavallo v1.jpg",
          "hash": "large_Cavallo_v1_aa6d5067d0",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 1000,
          "height": 1000,
          "size": 82.16,
          "path": null,
          "url": "/uploads/large_Cavallo_v1_aa6d5067d0.jpg"
        },
        "medium": {
          "name": "medium_Cavallo v1.jpg",
          "hash": "medium_Cavallo_v1_aa6d5067d0",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 750,
          "height": 750,
          "size": 50.44,
          "path": null,
          "url": "/uploads/medium_Cavallo_v1_aa6d5067d0.jpg"
        },
        "small": {
          "name": "small_Cavallo v1.jpg",
          "hash": "small_Cavallo_v1_aa6d5067d0",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 500,
          "height": 500,
          "size": 26.48,
          "path": null,
          "url": "/uploads/small_Cavallo_v1_aa6d5067d0.jpg"
        }
      },
      "hash": "Cavallo_v1_aa6d5067d0",
      "ext": ".jpg",
      "mime": "image/jpeg",
      "size": 161.66,
      "url": "/uploads/Cavallo_v1_aa6d5067d0.jpg",
      "previewUrl": null,
      "provider": "local",
      "provider_metadata": null,
      "created_at": "2025-02-22T12:36:02.148Z",
      "updated_at": "2025-02-22T12:36:02.160Z"
    },
    "localizations": []
  },
  {
    "id": 24,
    "price": 20,
    "abstract": "<p>Tagliato a mano circa 20/35 cm. Masticativo impegnativo e di lunga durata con consistenza esterna molto più sostenuta dell'interna, il prodotto presenta un alta appetibilità.</p>\n",
    "description": "<p><strong>Tagliato a mano circa 20/35 cm. Masticativo impegnativo e di lunga durata con consistenza esterna molto più sostenuta dell'interna, il prodotto presenta un alta appetibilità.</strong></p>\n<p>🔹 <strong>Altamente appagante</strong> per il cane esperto in attività di masticazione<br>\n🔹 <strong>Adatto sia a cani adolescenti e adulti esperti</strong><br>\n🔹 <strong>Sconsigliato a cuccioli e cani anziani</strong></p>\n<h2>⚠️ Avvertenze</h2>\n<ul>\n<li>Si consiglia, alle prime somministrazioni, la supervisione durante l'attività masticatoria, poiché alcuni cani tendono a  ingerire rapidamente il prodotto, anche non correttamente masticato.</li>\n<li>È importante che un professionista valuti le capacità masticatorie del cane.</li>\n</ul>\n<h2>Frequenza e utilizzo consigliato</h2>\n<p>✔️ <strong>Cani fino a 20 kg:</strong> 1-2 volte a settimana<br>\n✔️ <strong>Cani dai 30 kg in su:</strong> 3-4 volte a settimana<br>\n✔️ Consigliato in attività di recupero e defaticamento mentale nonchè in attività di lavorazione su problematiche di attaccamento e distacco.</p>\n<h2>⚠️ Digeribilità e precauzioni</h2>\n<ul>\n<li><strong>Bassa digeribilità:</strong> si raccomanda un uso moderato.</li>\n<li><strong>Dopo il consumo:</strong> evitare attività fisica intensa per permettere una corretta digestione.</li>\n<li><strong>Osservazioni:</strong> in alcuni soggetti, sono stati riscontrati frammenti non digeriti nelle feci.</li>\n<li><strong>Valutazione preventiva:</strong> è essenziale un'attenta analisi delle capacità masticatorie e delle condizioni digestive e intestinali del cane per evitare sovraccarichi organici, nel caso di soggetti non in buona salute chiedere consiglio al proprio veterinario prima del consumo.</li>\n</ul>\n",
    "name": "Nervo di Bovino Lungo",
    "slug": "nervo-lungo",
    "specs": "<p>🔬 <strong>Analisi nutrizionale</strong> (valori in g per 100 g):</p>\n<ul>\n<li><strong>Umidità</strong>: 8,47 g <em>(Rapporti ISTISAN 1996/34 pag.7 Met. B ± 0,2)</em></li>\n<li><strong>Sostanze grasse totali</strong>: 4,35 g <em>(MP/C/071 rev3 06/20 ± 0,20)</em></li>\n<li><strong>Sostanze azotate totali (Proteine)</strong>: 66,2 g <em>(MP/C/057 rev5 06/20 ± 0,40)</em></li>\n<li><strong>Ceneri</strong>: 3,67 g <em>(MP/C/056 rev3 06/20 ± 0,030)</em></li>\n<li><strong>Fibra</strong>: 1,14 g <em>(AACC method 32-10.01)</em></li>\n</ul>\n",
    "Tipo": "Bovino",
    "Order": 9,
    "isComingSoon": false,
    "locale": "it",
    "published_at": "2025-04-19T09:25:15.492Z",
    "created_at": "2025-04-19T09:25:11.477Z",
    "updated_at": "2025-07-14T07:35:06.594Z",
    "img": {
      "id": 61,
      "name": "Nervo Lungo v1.jpg",
      "alternativeText": "",
      "caption": "",
      "width": 1600,
      "height": 1600,
      "formats": {
        "thumbnail": {
          "name": "thumbnail_Nervo Lungo v1.jpg",
          "hash": "thumbnail_Nervo_Lungo_v1_937910cbd1",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 156,
          "height": 156,
          "size": 3.79,
          "path": null,
          "url": "/uploads/thumbnail_Nervo_Lungo_v1_937910cbd1.jpg"
        },
        "large": {
          "name": "large_Nervo Lungo v1.jpg",
          "hash": "large_Nervo_Lungo_v1_937910cbd1",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 1000,
          "height": 1000,
          "size": 68.51,
          "path": null,
          "url": "/uploads/large_Nervo_Lungo_v1_937910cbd1.jpg"
        },
        "medium": {
          "name": "medium_Nervo Lungo v1.jpg",
          "hash": "medium_Nervo_Lungo_v1_937910cbd1",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 750,
          "height": 750,
          "size": 43.26,
          "path": null,
          "url": "/uploads/medium_Nervo_Lungo_v1_937910cbd1.jpg"
        },
        "small": {
          "name": "small_Nervo Lungo v1.jpg",
          "hash": "small_Nervo_Lungo_v1_937910cbd1",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 500,
          "height": 500,
          "size": 23.54,
          "path": null,
          "url": "/uploads/small_Nervo_Lungo_v1_937910cbd1.jpg"
        }
      },
      "hash": "Nervo_Lungo_v1_937910cbd1",
      "ext": ".jpg",
      "mime": "image/jpeg",
      "size": 130.66,
      "url": "/uploads/Nervo_Lungo_v1_937910cbd1.jpg",
      "previewUrl": null,
      "provider": "local",
      "provider_metadata": null,
      "created_at": "2025-04-19T09:36:50.048Z",
      "updated_at": "2025-04-19T09:41:58.216Z"
    },
    "localizations": []
  },
  {
    "id": 25,
    "price": 20,
    "abstract": "<p>Masticativo naturale, duro e resistente. Favorisce l’igiene orale e rafforza la mascella. Il pelo aiuta la pulizia intestinale e sostiene la salute digestiva</p>\n",
    "description": "<p>Disponibile a breve...</p>\n",
    "name": "Orecchio di Bovino con Pelo",
    "slug": "orecchio-con-pelo",
    "specs": "<p>🔬 <strong>Analisi nutrizionale</strong> (valori in g per 100 g):</p>\n<ul>\n<li><strong>Umidità</strong>: 11,1 g <em>(Rapporti ISTISAN 1996/34 pag.7 Met. B ± 0,2)</em></li>\n<li><strong>Sostanze grasse totali</strong>: 5,16 g <em>(MP/C/071 rev3 06/20 ± 0,28)</em></li>\n<li><strong>Sostanze azotate totali (Proteine)</strong>: 75,2 g <em>(MP/C/057 rev5 06/20 ± 0,40)</em></li>\n<li><strong>Ceneri</strong>: 4,72 g <em>(MP/C/056 rev3 06/20)</em></li>\n<li><strong>Fibra</strong>: 3,23 g <em>(AACC method 32-10.01)</em></li>\n</ul>\n",
    "Tipo": "Bovino",
    "Order": 12,
    "isComingSoon": false,
    "locale": "it",
    "published_at": "2025-04-19T09:42:11.075Z",
    "created_at": "2025-04-19T09:42:07.581Z",
    "updated_at": "2025-07-14T07:41:08.013Z",
    "img": {
      "id": 62,
      "name": "Orecchio con Pelo v1.jpg",
      "alternativeText": "",
      "caption": "",
      "width": 1600,
      "height": 1600,
      "formats": {
        "thumbnail": {
          "name": "thumbnail_Orecchio con Pelo v1.jpg",
          "hash": "thumbnail_Orecchio_con_Pelo_v1_0ccaccce40",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 156,
          "height": 156,
          "size": 3.32,
          "path": null,
          "url": "/uploads/thumbnail_Orecchio_con_Pelo_v1_0ccaccce40.jpg"
        },
        "large": {
          "name": "large_Orecchio con Pelo v1.jpg",
          "hash": "large_Orecchio_con_Pelo_v1_0ccaccce40",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 1000,
          "height": 1000,
          "size": 73.61,
          "path": null,
          "url": "/uploads/large_Orecchio_con_Pelo_v1_0ccaccce40.jpg"
        },
        "medium": {
          "name": "medium_Orecchio con Pelo v1.jpg",
          "hash": "medium_Orecchio_con_Pelo_v1_0ccaccce40",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 750,
          "height": 750,
          "size": 44.38,
          "path": null,
          "url": "/uploads/medium_Orecchio_con_Pelo_v1_0ccaccce40.jpg"
        },
        "small": {
          "name": "small_Orecchio con Pelo v1.jpg",
          "hash": "small_Orecchio_con_Pelo_v1_0ccaccce40",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 500,
          "height": 500,
          "size": 23.07,
          "path": null,
          "url": "/uploads/small_Orecchio_con_Pelo_v1_0ccaccce40.jpg"
        }
      },
      "hash": "Orecchio_con_Pelo_v1_0ccaccce40",
      "ext": ".jpg",
      "mime": "image/jpeg",
      "size": 147,
      "url": "/uploads/Orecchio_con_Pelo_v1_0ccaccce40.jpg",
      "previewUrl": null,
      "provider": "local",
      "provider_metadata": null,
      "created_at": "2025-04-19T09:36:50.065Z",
      "updated_at": "2025-04-19T09:36:50.071Z"
    },
    "localizations": []
  },
  {
    "id": 26,
    "price": 20,
    "abstract": "<p>Proteico e povero di grassi. Per cani piccoli, si consiglia il taglio in pezzi.</p>\n",
    "description": "<p>Disponibile a breve...</p>\n",
    "name": "Muso di Suino",
    "slug": "muso",
    "specs": "<p>🔬 <strong>Analisi nutrizionale</strong> (valori in g per 100 g):</p>\n<ul>\n<li><strong>Umidità</strong>: 6,72 g <em>(Rapporti ISTISAN 1996/34 pag.7 Met. B ± 0,2)</em></li>\n<li><strong>Sostanze grasse totali</strong>: 10,8 g <em>(MP/C/071 rev3 06/20 ± 0,30)</em></li>\n<li><strong>Sostanze azotate totali (Proteine)</strong>: 71,6 g <em>(MP/C/057 rev5 06/20 ± 0,40)</em></li>\n<li><strong>Ceneri</strong>: 8,16 g <em>(MP/C/056 rev3 06/20)</em></li>\n<li><strong>Fibra</strong>: 0,92 g <em>(AACC method 32-10.01)</em></li>\n</ul>\n",
    "Tipo": "Suino",
    "Order": 15,
    "isComingSoon": false,
    "locale": "it",
    "published_at": "2025-04-19T09:44:06.412Z",
    "created_at": "2025-04-19T09:44:01.325Z",
    "updated_at": "2025-07-14T07:38:15.742Z",
    "img": {
      "id": 59,
      "name": "Muso v1.jpg",
      "alternativeText": "",
      "caption": "",
      "width": 1600,
      "height": 1600,
      "formats": {
        "thumbnail": {
          "name": "thumbnail_Muso v1.jpg",
          "hash": "thumbnail_Muso_v1_e4c7a92147",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 156,
          "height": 156,
          "size": 3.19,
          "path": null,
          "url": "/uploads/thumbnail_Muso_v1_e4c7a92147.jpg"
        },
        "large": {
          "name": "large_Muso v1.jpg",
          "hash": "large_Muso_v1_e4c7a92147",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 1000,
          "height": 1000,
          "size": 67.13,
          "path": null,
          "url": "/uploads/large_Muso_v1_e4c7a92147.jpg"
        },
        "medium": {
          "name": "medium_Muso v1.jpg",
          "hash": "medium_Muso_v1_e4c7a92147",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 750,
          "height": 750,
          "size": 40.66,
          "path": null,
          "url": "/uploads/medium_Muso_v1_e4c7a92147.jpg"
        },
        "small": {
          "name": "small_Muso v1.jpg",
          "hash": "small_Muso_v1_e4c7a92147",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 500,
          "height": 500,
          "size": 21.31,
          "path": null,
          "url": "/uploads/small_Muso_v1_e4c7a92147.jpg"
        }
      },
      "hash": "Muso_v1_e4c7a92147",
      "ext": ".jpg",
      "mime": "image/jpeg",
      "size": 133.76,
      "url": "/uploads/Muso_v1_e4c7a92147.jpg",
      "previewUrl": null,
      "provider": "local",
      "provider_metadata": null,
      "created_at": "2025-04-19T09:36:50.009Z",
      "updated_at": "2025-04-19T09:36:50.022Z"
    },
    "localizations": []
  },
  {
    "id": 27,
    "price": 20,
    "abstract": "<p>Masticativo duro e proteico, ideale per lavorare cani reattivi o con alta motivazione predatoria.</p>\n",
    "description": "<p>Disponibile a breve...</p>\n",
    "name": "Pelle Nucale di Suino",
    "slug": "pelle-nucale",
    "specs": "<p>🔬 <strong>Analisi nutrizionale</strong> (valori in g per 100 g):</p>\n<ul>\n<li><strong>Umidità</strong>: 8,24 g <em>(Rapporti ISTISAN 1996/34 pag.7 Met. B ± 0,2)</em></li>\n<li><strong>Sostanze grasse totali</strong>: 15,1 g <em>(MP/C/071 rev3 06/20 ± 0,30)</em></li>\n<li><strong>Sostanze azotate totali (Proteine)</strong>: 69,8 g <em>(MP/C/057 rev5 06/20 ± 0,40)</em></li>\n<li><strong>Ceneri</strong>: 4,13 g <em>(MP/C/056 rev3 06/20)</em></li>\n<li><strong>Fibra</strong>: 2,05 g <em>(AACC method 32-10.01)</em></li>\n</ul>\n",
    "Tipo": "Suino",
    "Order": 16,
    "isComingSoon": false,
    "locale": "it",
    "published_at": "2025-04-19T09:48:04.185Z",
    "created_at": "2025-04-19T09:48:01.891Z",
    "updated_at": "2025-07-14T07:38:04.001Z",
    "img": {
      "id": 64,
      "name": "Pelle Nucale v1.jpg",
      "alternativeText": "",
      "caption": "",
      "width": 1600,
      "height": 1600,
      "formats": {
        "thumbnail": {
          "name": "thumbnail_Pelle Nucale v1.jpg",
          "hash": "thumbnail_Pelle_Nucale_v1_7144ab8efb",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 156,
          "height": 156,
          "size": 3.58,
          "path": null,
          "url": "/uploads/thumbnail_Pelle_Nucale_v1_7144ab8efb.jpg"
        },
        "large": {
          "name": "large_Pelle Nucale v1.jpg",
          "hash": "large_Pelle_Nucale_v1_7144ab8efb",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 1000,
          "height": 1000,
          "size": 77.11,
          "path": null,
          "url": "/uploads/large_Pelle_Nucale_v1_7144ab8efb.jpg"
        },
        "medium": {
          "name": "medium_Pelle Nucale v1.jpg",
          "hash": "medium_Pelle_Nucale_v1_7144ab8efb",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 750,
          "height": 750,
          "size": 46.82,
          "path": null,
          "url": "/uploads/medium_Pelle_Nucale_v1_7144ab8efb.jpg"
        },
        "small": {
          "name": "small_Pelle Nucale v1.jpg",
          "hash": "small_Pelle_Nucale_v1_7144ab8efb",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 500,
          "height": 500,
          "size": 24.47,
          "path": null,
          "url": "/uploads/small_Pelle_Nucale_v1_7144ab8efb.jpg"
        }
      },
      "hash": "Pelle_Nucale_v1_7144ab8efb",
      "ext": ".jpg",
      "mime": "image/jpeg",
      "size": 152.81,
      "url": "/uploads/Pelle_Nucale_v1_7144ab8efb.jpg",
      "previewUrl": null,
      "provider": "local",
      "provider_metadata": null,
      "created_at": "2025-04-19T09:46:11.873Z",
      "updated_at": "2025-04-19T09:46:11.881Z"
    },
    "localizations": []
  },
  {
    "id": 28,
    "price": 20,
    "abstract": "<p>In arrivo...</p>\n",
    "description": "<p>In arrivo...</p>\n",
    "name": "Milza di Bovino",
    "slug": "milza",
    "specs": "<p>🔬 <strong>Analisi nutrizionale</strong> (valori in g per 100 g):</p>\n<ul>\n<li><strong>Umidità</strong>: 12,2 g <em>(Rapporti ISTISAN 1996/34 pag.7 Met. B ± 0,2)</em></li>\n<li><strong>Sostanze grasse totali</strong>: 8,55 g <em>(MP/C/071 rev3 06/20 ± 0,28)</em></li>\n<li><strong>Sostanze azotate totali (Proteine)</strong>: 72,0 g <em>(MP/C/057 rev5 06/20 ± 0,40)</em></li>\n<li><strong>Ceneri</strong>: 5,49 g <em>(MP/C/056 rev3 06/20)</em></li>\n<li><strong>Fibra</strong>: 1,61 g <em>(AACC method 32-10.01)</em></li>\n</ul>\n",
    "Tipo": "Bovino",
    "Order": 10,
    "isComingSoon": true,
    "locale": "it",
    "published_at": "2025-07-14T07:40:47.623Z",
    "created_at": "2025-07-14T07:40:45.204Z",
    "updated_at": "2025-07-14T12:48:52.887Z",
    "img": {
      "id": 68,
      "name": "Milza v1.jpg",
      "alternativeText": "",
      "caption": "",
      "width": 1600,
      "height": 1600,
      "formats": {
        "thumbnail": {
          "name": "thumbnail_Milza v1.jpg",
          "hash": "thumbnail_Milza_v1_ba49a8a4b2",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 156,
          "height": 156,
          "size": 3.84,
          "path": null,
          "url": "/uploads/thumbnail_Milza_v1_ba49a8a4b2.jpg"
        },
        "large": {
          "name": "large_Milza v1.jpg",
          "hash": "large_Milza_v1_ba49a8a4b2",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 1000,
          "height": 1000,
          "size": 99.97,
          "path": null,
          "url": "/uploads/large_Milza_v1_ba49a8a4b2.jpg"
        },
        "medium": {
          "name": "medium_Milza v1.jpg",
          "hash": "medium_Milza_v1_ba49a8a4b2",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 750,
          "height": 750,
          "size": 59.35,
          "path": null,
          "url": "/uploads/medium_Milza_v1_ba49a8a4b2.jpg"
        },
        "small": {
          "name": "small_Milza v1.jpg",
          "hash": "small_Milza_v1_ba49a8a4b2",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 500,
          "height": 500,
          "size": 30.44,
          "path": null,
          "url": "/uploads/small_Milza_v1_ba49a8a4b2.jpg"
        }
      },
      "hash": "Milza_v1_ba49a8a4b2",
      "ext": ".jpg",
      "mime": "image/jpeg",
      "size": 205.61,
      "url": "/uploads/Milza_v1_ba49a8a4b2.jpg",
      "previewUrl": null,
      "provider": "local",
      "provider_metadata": null,
      "created_at": "2025-07-14T07:42:02.986Z",
      "updated_at": "2025-07-14T07:42:02.997Z"
    },
    "localizations": []
  },
  {
    "id": 29,
    "price": 20,
    "abstract": "<p>In arrivo...</p>\n",
    "description": "<p>In arrivo...</p>\n",
    "name": "Trippa verde di Bovino",
    "slug": "trippa-verde",
    "specs": "<p>🔬 <strong>Analisi nutrizionale</strong> (valori in g per 100 g):</p>\n<ul>\n<li><strong>Umidità</strong>: 10,9 g <em>(Rapporti ISTISAN 1996/34 pag.7 Met. B ± 0,2)</em></li>\n<li><strong>Sostanze grasse totali</strong>: 8,19 g <em>(MP/C/071 rev3 06/20 ± 0,28)</em></li>\n<li><strong>Sostanze azotate totali (Proteine)</strong>: 74,5 g <em>(MP/C/057 rev5 06/20 ± 0,40)</em></li>\n<li><strong>Ceneri</strong>: 4,31 g <em>(MP/C/056 rev3 06/20)</em></li>\n<li><strong>Fibra</strong>: 2,01 g <em>(AACC method 32-10.01)</em></li>\n</ul>\n",
    "Tipo": "Bovino",
    "Order": 11,
    "isComingSoon": true,
    "locale": "it",
    "published_at": "2025-07-14T07:43:18.671Z",
    "created_at": "2025-07-14T07:43:16.333Z",
    "updated_at": "2025-07-14T12:49:05.159Z",
    "img": {
      "id": 69,
      "name": "Trippa verde v1.jpg",
      "alternativeText": "",
      "caption": "",
      "width": 1600,
      "height": 1600,
      "formats": {
        "thumbnail": {
          "name": "thumbnail_Trippa verde v1.jpg",
          "hash": "thumbnail_Trippa_verde_v1_f37c940adc",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 156,
          "height": 156,
          "size": 3.75,
          "path": null,
          "url": "/uploads/thumbnail_Trippa_verde_v1_f37c940adc.jpg"
        },
        "large": {
          "name": "large_Trippa verde v1.jpg",
          "hash": "large_Trippa_verde_v1_f37c940adc",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 1000,
          "height": 1000,
          "size": 91.39,
          "path": null,
          "url": "/uploads/large_Trippa_verde_v1_f37c940adc.jpg"
        },
        "medium": {
          "name": "medium_Trippa verde v1.jpg",
          "hash": "medium_Trippa_verde_v1_f37c940adc",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 750,
          "height": 750,
          "size": 53.84,
          "path": null,
          "url": "/uploads/medium_Trippa_verde_v1_f37c940adc.jpg"
        },
        "small": {
          "name": "small_Trippa verde v1.jpg",
          "hash": "small_Trippa_verde_v1_f37c940adc",
          "ext": ".jpg",
          "mime": "image/jpeg",
          "width": 500,
          "height": 500,
          "size": 27.63,
          "path": null,
          "url": "/uploads/small_Trippa_verde_v1_f37c940adc.jpg"
        }
      },
      "hash": "Trippa_verde_v1_f37c940adc",
      "ext": ".jpg",
      "mime": "image/jpeg",
      "size": 199.71,
      "url": "/uploads/Trippa_verde_v1_f37c940adc.jpg",
      "previewUrl": null,
      "provider": "local",
      "provider_metadata": null,
      "created_at": "2025-07-14T07:43:09.496Z",
      "updated_at": "2025-07-14T07:43:09.505Z"
    },
    "localizations": []
  }
]